import React from 'react';
import { List } from 'immutable';

import Node from './Node';

interface CategoriesProps {
  tree: List<any>;
  onCategoryClick: (...args: any[]) => void;
}

const Categories: React.FC<CategoriesProps> = ({ tree, onCategoryClick }) =>
  tree.map((item) => (
    <Node onCategoryClick={onCategoryClick} key={item.id} item={item} level={item.level} tree={item.children} />
  )) as unknown as React.ReactElement;

export default Categories;
